export default __webpack_public_path__ + "static/media/white-thumb-down.f525112c.svg";